import assetUrl from 'mk/common/assetUrl';
import { Props } from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrdersPage';
import Btn from 'mk2/components/Btn';
import React from 'react';
import styles from './PaymentOrders.mscss';

export interface PaymentXLSData {
    Meno?: string;
    Platba?: number;
    IBAN?: string;
    BIC?: string;
    VS?: number;
    KS?: number;
    Info?: string;
}

export default class PaymentOrders extends React.Component<Props> {

    public render() {
        const { outputFilename, outputXML, errorMessage } = this.props;

        return (
            <div className={styles.PaymentOrders}>
                <div className={styles.PaymentOrders__form}>
                    <input
                        type="file"
                        name="upload"
                        id="upload"
                        onClick={this.handleOnFileClick}
                        onChange={this.handleOnFileChange}
                    />
                    {errorMessage && (
                        <div className={styles.PaymentOrders__error}>
                            {errorMessage}
                        </div>
                    )}

                    <Btn
                        className={styles.PaymentOrders__download}
                        icon="fa-download"
                        label="Download"
                        onClick={this.handleOnDownloadXML}
                        disabled={!outputFilename || !outputXML}
                    />

                    <a
                        className={styles.PaymentOrders__example}
                        href={assetUrl + 'docs/bo_payment_orders.xlsx'}
                        download
                    >
                        Download XLS sample
                    </a>
                </div>
            </div>
        );
    }

    private handleOnFileClick = (ev) => {
        // reset current file, so that we can select the same file again
        ev.target.value = '';
    };

    private handleOnFileChange = (ev) => {
        ev.preventDefault();

        const { onOpenXLS } = this.props;
        const file = ev.target.files[0];
        onOpenXLS(file);
    };

    private handleOnDownloadXML = () => {
        const { outputFilename, outputXML } = this.props;

        const element = document.createElement('a');
        const file = new Blob([outputXML], {type: 'application/xml'});
        element.href = URL.createObjectURL(file);
        element.download = outputFilename + '.xml';
        element.click();
    };

}
